import { Pill, type UseModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { type ChartingContextData } from "@src/appV2/Shifts/Shift/useGetChartingCredentials";

import { YourChartingLoginBottomSheetContainer } from "../../redesign/Charting/YourChartingLoginBottomSheetContainer";
import { ChatActionCard } from "../../redesign/Chat/ChatActionCard";
import { Button } from "../../redesign/components/Button";

interface WorkerCredentialSharedMessageCardProps {
  workerId: string;
  workplaceId: string;
  chartingCredential: ChartingContextData;
  chartingCredentialsModalState: UseModalState;
}

export function WorkerCredentialSharedMessageCard(props: WorkerCredentialSharedMessageCardProps) {
  const { workerId, workplaceId, chartingCredential, chartingCredentialsModalState } = props;

  const logMetadata = {
    timestamp: new Date().toISOString(),
    workerId,
    workplaceId,
  };

  return (
    <ChatActionCard
      message="Use this login to access the facility's charting platform during your shift."
      pill={
        <Pill
          variant="outlined"
          size="small"
          label="Charting login"
          backgroundColor={(theme) => theme.palette.background.quaternary}
          color={(theme) => theme.palette.text.primary}
          outlineColor={(theme) => theme.palette.intent?.neutral.border}
          sx={{
            width: "fit-content",
          }}
        />
      }
    >
      <Button
        fullWidth
        variant="contained"
        size="small"
        onClick={() => {
          logEvent(
            APP_V2_USER_EVENTS.WORKER_CREDENTIAL_SHARED_MESSAGE_VIEW_LOGIN_BUTTON_CLICKED,
            logMetadata
          );
          chartingCredentialsModalState.openModal();
        }}
      >
        View login details
      </Button>

      <YourChartingLoginBottomSheetContainer
        modalState={chartingCredentialsModalState}
        chartingCredentials={chartingCredential.chartingCredential}
        workerId={workerId}
        workplaceId={workplaceId}
      />
    </ChatActionCard>
  );
}
